import { HOME_MOVES_MOVE_OUT_COMPLETE } from '@/src/constants/analytics-subjects';
import { ChangedMindAboutTakingOVOSection } from '@/src/pages/MovingHome/components/ChangedMindAboutTakingOVOSection/ChangedMindAboutTakingOVOSection';
import { MovingHomePaymentSection } from '@/src/pages/MovingHome/components/MovingHomePaymentSection/MovingHomePaymentSection';
import {
  Card,
  Heading1,
  Heading4,
  Margin,
  P,
  Stack,
  Strong,
} from '@ovotech/element-v4';
import { useAnalytics } from '@ovotech/ui-tools';
import React, { useEffect, useMemo } from 'react';
import { formatMoveOutAddress } from '../../utils/formatMoveOutAddress';
import styles from './ContractTerminatedSection.module.css';
import { HomeMovesCustomerData } from '@/src/api/home-moves';

const DisplayAddress = ({
  moveOutCustomer,
}: {
  moveOutCustomer?: HomeMovesCustomerData;
}) => {
  const address = formatMoveOutAddress(moveOutCustomer);
  if (!address) return undefined;
  return <Strong>{address}</Strong>;
};

export function ContractTerminatedSection({
  moveOutCustomer,
  currentAddress,
  moveOutDate,
}: {
  currentAddress: string;
  moveOutDate: string;
  moveOutCustomer?: HomeMovesCustomerData;
}) {
  const movingDateText = useMemo(() => {
    const date = new Date(moveOutDate);

    return new Intl.DateTimeFormat('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
  }, [moveOutDate]);

  const { dispatch } = useAnalytics();

  useEffect(() => {
    dispatch({
      type: 'view',
      name: HOME_MOVES_MOVE_OUT_COMPLETE,
      properties: {
        status: 'notTakingOvo',
      },
    });
  }, [dispatch]);

  return (
    <Stack spaceBetween={[6, 7, 5]}>
      <Card>
        <Heading1>You’ve moved home</Heading1>
        <Margin bottom={[8, 5, 10]} />

        <Stack spaceBetween={3}>
          <Heading4 className={styles.subtitle}>Your old address</Heading4>
          <Heading4 className={styles.address}>{currentAddress}</Heading4>
          <P>
            Thanks for letting us know you moved out on{' '}
            <Strong>{movingDateText}</Strong>.
            {moveOutCustomer ? (
              <>
                {' '}
                A final bill will be sent to your new address{' '}
                <DisplayAddress moveOutCustomer={moveOutCustomer} /> within 6
                weeks of your moving day.
              </>
            ) : (
              ''
            )}{' '}
            Thank you for your time with us — we hope you'll come back to us
            soon!
          </P>
          <P>
            Something’s not right? Please call us on 0330 303 5063 from 9am to
            5pm, Monday to Friday.
          </P>
        </Stack>
      </Card>

      <MovingHomePaymentSection />

      <ChangedMindAboutTakingOVOSection />
    </Stack>
  );
}
